import type { PropsWithChildren, ReactElement } from 'react';
import './Loading.scss';

import { LoadingState } from '@fastnorth/react-cerberus/LoadingState';

type LoadingProps = {
  busy: boolean;
  className?: string;
};

const Loading = ({ busy, className, children }: PropsWithChildren<LoadingProps>): ReactElement => {
  if (busy) {
    return <LoadingState className={`${className} Loading__container`} />;
  }
  return <>{children}</>;
};

export default Loading;
